import { datadogLogs } from '@datadog/browser-logs';

export const logReportPerformance = (
  reportType: 'Allocation' | 'Availability',
  campaignType: string,
  loadTimeInMs: number,
  networkSpeed?: number | null,
): void => {
  const logData = {
    tradingType: campaignType,
    networkSpeedInMbps: networkSpeed || null,
  };

  if (reportType === 'Allocation') {
    datadogLogs.logger.info('Allocation Report loaded', {
      ...logData,
      allocationReportLoadTimeInMs: Math.trunc(loadTimeInMs),
    });
  } else {
    datadogLogs.logger.info('Availability Report loaded', {
      ...logData,
      availabilityReportLoadTimeInMs: Math.trunc(loadTimeInMs),
    });
  }
};

export const calculateLoadTime = (startTime?: number): number => {
  if (!startTime) return 0;
  return performance.now() - startTime;
};

export const getNetworkSpeed = (): number | null => {
  return navigator.connection?.downlink || null;
};
